import {MessageProvider} from '@messageformat/react';
import React, {createContext, useEffect, useState} from 'react';
import locale from '../../locale';

const LocaleContext = createContext();

export const LocaleController = ({children}) => {
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    let storedLanguage = localStorage.getItem('language');

    if (!storedLanguage) {
      const browserLanguage = (navigator.language || navigator.userLanguage || '' ).toLowerCase();
      
      if (browserLanguage.includes('pl')) {
        storedLanguage = 'pl-PL';
      } else if (browserLanguage.includes('en')) {
        storedLanguage = 'en-GB';
      } else {
        storedLanguage = 'en-GB';
      }

      localStorage.setItem('language', storedLanguage);
    }

    setLanguage(storedLanguage);
  }, [language]);

  const updateLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const availableLanguages = [
    {
      code: 'pl-PL',
      name: 'Polski',
    },
    {
      code: 'en-GB',
      name: 'English',
    },
    {
      code: 'cs-CZ',
      name: 'Čeština',
    },
    {
      code: 'de-DE',
      name: 'Deutsch',
    },
  ];

  return language && (
    <LocaleContext.Provider
      value={{language, updateLanguage, setLanguage, availableLanguages}}>
      <MessageProvider locale={language} messages={locale[language]}>
        {children}
      </MessageProvider>
    </LocaleContext.Provider>
  );
};

export default LocaleContext;
